import { createProject, updateProject } from "api/mutations/project";
import { trackProject } from "api/mutations/project/project";
import { TCreateProjectBody, TCreateProjectResponse, TUpdateProjectBody } from "interface";
import {
  useMutation, UseMutationResult
} from "react-query";
import { IError } from "rules/interface/api/error.interface";
import { IApiRequestDataWithId, IServerResponse } from "rules/interface/api/response";
import ITrackProject from "rules/interface/project/track.interface";


export const useCreateProject = (): UseMutationResult<IServerResponse<TCreateProjectResponse>, any, TCreateProjectBody> => {
  return useMutation((body: TCreateProjectBody) => createProject(body));
};



export const useUpdateProject = (): UseMutationResult<IServerResponse<TCreateProjectResponse>, IError, TUpdateProjectBody> => {
  return useMutation((body: TUpdateProjectBody) => updateProject(body));
};

export const useTrackProject = (): UseMutationResult<IServerResponse<{}>, IError, IApiRequestDataWithId<ITrackProject>> => {
  return useMutation((body: IApiRequestDataWithId<ITrackProject>) => trackProject(body));
};